module.exports = __webpack_public_path__ + "img/add_student1.fd0d2545.png";